export function getDifficultyCategory(difficulty: number | undefined): string {
  if (difficulty == null) return 'Beginner';
  if (difficulty <= 2) return 'Beginner';
  if (difficulty === 3) return 'Intermediate';
  return 'Advanced';
}

export function getDifficultyLabel(difficulty: number | undefined): string {
  return getDifficultyCategory(difficulty);
}

export function getDifficultyStars(difficulty: number | undefined): string {
  if (difficulty == null) return '★☆☆☆☆';
  const filled = Math.min(Math.max(difficulty, 1), 5);
  return '★'.repeat(filled) + '☆'.repeat(5 - filled);
}
